// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"536":"2ea5c965","805":"34e62651"}[chunkId] + ".chunk.css";
};